import React, { useState, type FormEvent } from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { PageHero } from '../components/PageHero';
export function PlanTrekPage() {
  const [submitted, setSubmitted] = useState(false);
  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setSubmitted(true);
  }
  return <main className="bg-[#f7f4ec] text-[#1d2d2a]" data-id="element-621" data-mp="2nxoitzlshoa1">
      <PageHero eyebrow="Tailor your Manaslu journey" title="Plan your trek, thoughtfully." description="Share your preferred season, group size and travel style. Our local team will shape a realistic Manaslu plan around your needs." image="https://images.unsplash.com/photo-1486911278844-a81c5267e227?auto=format&fit=crop&w=1800&q=85" data-id="element-622" data-mp="3lkdvd3e4bja5" />
      <section className="mx-auto grid max-w-6xl gap-12 px-5 py-20 sm:px-8 sm:py-28 lg:grid-cols-[0.75fr_1.25fr] lg:px-10" data-id="element-623" data-mp="37mfki7z0a4ze">
        <aside data-id="element-624" data-mp="1w4ee0z0cinjf">
          <p className="eyebrow" data-id="element-625" data-mp="1w3uvph6s9x4v">Your next step</p>
          <h2 className="mt-4 font-display text-4xl" data-id="element-626" data-mp="1w7abkm8a7a7c">
            A useful plan begins with a few details.
          </h2>
          <ul className="mt-7 space-y-4 text-sm leading-6 text-[#55615a]" data-id="element-627" data-mp="2cxqm35u2ji2c">
            {['Recommended season and available departures', 'Small-group or private trek pricing', 'Permit, insurance and gear guidance', 'Practical pre-trip preparation notes'].map(item => <li key={item} className="flex gap-3" data-id="element-628" data-mp="1p6tiqhgc9t2p">
                <CheckCircle2Icon className="shrink-0 text-[#6D5A39]" size={19} aria-hidden="true" data-id="element-629" data-mp="1tyusnwq1b7pk" />
                {item}
              </li>)}
          </ul>
        </aside>
        <form onSubmit={handleSubmit} className="border border-[#c8c1af] p-6 sm:p-8" aria-label="Trek planning form" data-id="element-630" data-mp="1k9kvw3k8x0v4">
          {submitted ? <div role="status" className="py-14 text-center" data-id="element-631" data-mp="1b83kgyhs9ncr">
              <p className="eyebrow" data-id="element-632" data-mp="3cyc7bz5cwvtz">Trek request received</p>
              <h2 className="mt-4 font-display text-3xl" data-id="element-633" data-mp="3czvn7on3p4v8">
                We’ll help shape the right route.
              </h2>
              <p className="mx-auto mt-4 max-w-md text-sm leading-7 text-[#55615a]" data-id="element-634" data-mp="337pv8ewumng1">
                Our Kathmandu team will follow up with suitable dates, planning
                notes and a clear estimate.
              </p>
            </div> : <>
              <h2 className="font-display text-3xl" data-id="element-635" data-mp="3vuao5jsz37lp">Tell us about your trip</h2>
              <div className="mt-7 grid gap-5 sm:grid-cols-2" data-id="element-636" data-mp="3qyd4p4mexl4p">
                <label className="text-sm font-bold" data-id="element-637" data-mp="3mv70e2iv240v">
                  Name
                  <input required className="mt-2 w-full border border-[#c8c1af] bg-white px-4 py-3 font-normal outline-none focus:border-[#6D5A39]" data-id="element-638" data-mp="3hx5hpipck6px" />
                </label>
                <label className="text-sm font-bold" data-id="element-639" data-mp="26gxdzdy6ipco">
                  Email
                  <input required type="email" className="mt-2 w-full border border-[#c8c1af] bg-white px-4 py-3 font-normal outline-none focus:border-[#6D5A39]" data-id="element-640" data-mp="m0h5m6u8rb1c" />
                </label>
                <label className="text-sm font-bold" data-id="element-641" data-mp="uyjcv44kizx2">
                  Preferred season
                  <select className="mt-2 w-full border border-[#c8c1af] bg-white px-4 py-3 font-normal outline-none focus:border-[#6D5A39]" data-id="element-642" data-mp="zt72557ebycp">
                    <option data-id="element-643" data-mp="19oh8g54turwa">Spring (March–May)</option>
                    <option data-id="element-644" data-mp="19rd2vjhguyfz">Autumn (September–November)</option>
                    <option data-id="element-645" data-mp="1epog846yzr2y">I need advice</option>
                  </select>
                </label>
                <label className="text-sm font-bold" data-id="element-646" data-mp="1ionifh1bh9qp">
                  Group size
                  <select className="mt-2 w-full border border-[#c8c1af] bg-white px-4 py-3 font-normal outline-none focus:border-[#6D5A39]" data-id="element-647" data-mp="3gghwyusp2ecj">
                    <option data-id="element-648" data-mp="3kjecgcmxtuc9">1 traveler</option>
                    <option data-id="element-649" data-mp="2p6div5k6nnsk">2 travelers</option>
                    <option data-id="element-650" data-mp="2p5by29dd7mxn">3–6 travelers</option>
                    <option data-id="element-651" data-mp="2l6bf8quw0kan">7+ travelers</option>
                  </select>
                </label>
              </div>
              <label className="mt-5 block text-sm font-bold" data-id="element-652" data-mp="2z49oxiy9jsjt">
                Tell us about your experience and preferences
                <textarea rows={5} className="mt-2 w-full resize-y border border-[#c8c1af] bg-white px-4 py-3 font-normal outline-none focus:border-[#6D5A39]" data-id="element-653" data-mp="2u715zg5ajkhi" />
              </label>
              <button type="submit" className="mt-6 bg-[#A48C5A] px-6 py-4 text-sm font-bold text-[#172a27] transition-colors hover:bg-[#D9CAA0]" data-id="element-654" data-mp="2g66wsvaf5fhs">
                Request a plan
              </button>
            </>}
        </form>
      </section>
    </main>;
}